import { ChangeDetectionStrategy, Component, HostBinding, Input, inject } from '@angular/core';
import { Store } from '@ngxs/store';
import { AccountState } from '@shared/states/account.state';

@Component({
  selector: 'brand-name',
  templateUrl: './brand-name.component.html',
  styleUrls: ['./brand-name.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class BrandName {
  private store = inject(Store);

  @Input()
  @HostBinding('class')
  class: string;

  branding() {
    const branding = this.store.selectSnapshot(AccountState.parentBranding);
    // console.warn('<brand-name>', branding);
    return branding;
  }
}
